import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./newDashboard/auth/Login.jsx";
import Signup from "./newDashboard/auth/Signup.jsx";

import OwnerDashboardRouter from "./newDashboard/router/OwnerDashboardRouter.jsx";
import CharityDashboardRouter from "./newDashboard/router/CharityDashboardRouter.jsx";
import AdminDashboard from "./newDashboard/admin/AdminDashboard.jsx";
import AdminLayout from "./newDashboard/admin/AdminLayout.jsx";
import AdminAddBar from "./newDashboard/admin/AdminAddBar.jsx";
import AdminGamblingStates from "./newDashboard/admin/AdminGamblingStates.jsx";
import AdminPillStates from "./newDashboard/admin/AdminPillStates.jsx";
import StaffPost from "./newDashboard/staff/StaffPost.jsx";
import AdminImport from "./newDashboard/admin/AdminImport.jsx";
import AdminImportOakdale from "./newDashboard/admin/AdminImportOakdale.jsx";
import AdminSignups from "./newDashboard/admin/AdminSignups.jsx";
import AdminPosts from "./newDashboard/admin/AdminPosts.jsx";
import AdminNationalBars from "./newDashboard/admin/AdminNationalBars.jsx";
import AdminOutreach from "./newDashboard/admin/AdminOutreach.jsx";
import AdminReports from "./newDashboard/admin/AdminReports.jsx";
import AdminClaimed from "./newDashboard/admin/AdminClaimed.jsx";
import AdminDemo from "./newDashboard/admin/AdminDemo.jsx";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* PUBLIC */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        {/* Bartenders/cooks post today's food special with the staff code, no login */}
        <Route path="/staff-post" element={<StaffPost />} />

        {/* OWNER — the /* is required so nested tabs/pages can work */}
        <Route path="/owner/*" element={<OwnerDashboardRouter />} />

        {/* CHARITY — same reason */}
        <Route path="/charity/*" element={<CharityDashboardRouter />} />

        {/* ADMIN — internal only, gated inside the component itself */}
        <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        <Route path="/admin/add-bar" element={<AdminLayout><AdminAddBar /></AdminLayout>} />
        <Route path="/admin/gambling-states" element={<AdminLayout><AdminGamblingStates /></AdminLayout>} />
        <Route path="/admin/pills" element={<AdminLayout><AdminPillStates /></AdminLayout>} />
        <Route path="/admin/import" element={<AdminLayout><AdminImport /></AdminLayout>} />
        <Route path="/admin/import-oakdale" element={<AdminLayout><AdminImportOakdale /></AdminLayout>} />
        <Route path="/admin/signups" element={<AdminLayout><AdminSignups /></AdminLayout>} />
        <Route path="/admin/posts" element={<AdminLayout><AdminPosts /></AdminLayout>} />
        <Route path="/admin/national" element={<AdminLayout><AdminNationalBars /></AdminLayout>} />
        <Route path="/admin/outreach" element={<AdminLayout><AdminOutreach /></AdminLayout>} />
        <Route path="/admin/reports" element={<AdminLayout><AdminReports /></AdminLayout>} />
        <Route path="/admin/claimed" element={<AdminLayout><AdminClaimed /></AdminLayout>} />
        <Route path="/admin/demo" element={<AdminLayout><AdminDemo /></AdminLayout>} />

        {/* DEFAULT */}
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
}